import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["value"]

import { h, computed, ref, reactive, watchEffect } from 'vue';
  import { useI18n,  } from 'vue-i18n';
  import { FormItem } from '@/types/form';
  import { authStore } from '@/stores';
  import { useRoute } from 'vue-router';
  import AppAddressAutoComplete from '@/components/address-autocomplete/index.vue';
  import { Country, getCountryCodeByPhoneNumber } from '@/components/country-selector/countries';
  import PhoneNumberForm from './phone-number-form.vue';
  import _ from 'lodash';

  type Form = {
    [propName: string]: any;
  }
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const showChangePhoneNumber = ref(false);
  const countryCode = ref('');
  const route = useRoute();
  const isSignup = route.name === 'signup';
  const phoneNumberDialCode = ref<number | undefined>();
  const { t, locale } = useI18n();
  const form = reactive<Form>({
    phone_number: ''
  });

  const phoneNumber = computed(() => {
    if (form.phone_number) {
      return String(form.phone_number).startsWith('+') ? form.phone_number : `+${phoneNumberDialCode.value} ${form.phone_number}`;
    }
    return '';
  });

  function handleGetPhoneNumberCountry(country: Country) {
    phoneNumberDialCode.value = country.dialCode;
  }

  function onAddressAutoComplete(data: any) {
    Object.assign(form, data);
  }
  const contactInformationFormItems = computed<FormItem[]>(() => {
    return [
      {
        label: t('FIRST NAME'),
        type: 'input',
        key: 'first_name',
        required: true,
        placeholder: t('first_name_placeholder')
      },
      {
        label: t('LAST NAME'),
        type: 'input',
        key: 'last_name',
        required: true,
        placeholder: t('last_name_placeholder')
      },
      {
        label: t('NICKNAME'),
        type: 'input',
        key: 'nick_name',
        required: true,
        placeholder: t('nick_name_placeholder'),
        slots: {
          description: {
            template: `${t('nicknameTip.0')} <router-link target="_blank" :to="{ name: 'staticPage', params: { slug: 'privacy_policy' } }">${t('nicknameTip.1')}</router-link>.`
          }
        }
      },
      // 这里required验证会失效（只有样式），暂时只能依赖后端检查。
      {
        label: t('ADDRESS 1'),
        type: 'input',
        key: 'street_address',
        required: true,
        slots: {
          default: () => {
            return h(AppAddressAutoComplete, { onComplete: onAddressAutoComplete }, h({ template: `<b-form-input name="street_address" model-value="${form.street_address || ''}" readonly class="auto-complete-trigger" placeholder="${t('address_1_placeholder')}" />` }));
          },
        }
      },
      {
        label: t('ADDRESS 2'),
        type: 'input',
        key: 'extended_address',
        required: true,
        placeholder: t('address_2_placeholder')
      },
      {
        label: t('State'),
        type: 'input',
        key: 'region',
        placeholder: t('state_placeholder'),
        required: false,
        readonly: true
      },
      {
        label: t('City'),
        type: 'input',
        key: 'locality',
        required: false,
        placeholder: t('city_placeholder'),
        readonly: true
      },
      {
        label: t('ZIP CODE'),
        type: 'input',
        key: 'postal_code',
        required: true,
        placeholder: '08636',
        readonly: true
      },
      {
        label: t('PHONE NUMBER FORM LABEL'),
        type: 'input',
        key: 'phone_number',
        required: true,
        placeholder: '01012340000',
        disabled: !isSignup,
      },
      isSignup && {
        label: t('VERIFICATION CODE'),
        type: 'input',
        key: 'verification_code',
        required: true,
        placeholder: ''
      },
    ].filter(Boolean) as FormItem[];
  });

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  watchEffect(() => {
    let phoneNumber = '';
    if (!isSignup) {
      const originPhoneNumber = _.get(authStore.user, 'profile.phone_number');
      if (originPhoneNumber) {
        // 通过完整手机号还原国家code
        const phoneNumberCountryCode = getCountryCodeByPhoneNumber(originPhoneNumber);
        if (phoneNumberCountryCode) {
          countryCode.value = phoneNumberCountryCode;
        }
        // form显示不带dialCode的phoneNumber
        phoneNumber = originPhoneNumber.startsWith('+') ? originPhoneNumber.split(' ').slice(1).join(' ') : originPhoneNumber;
      }
    }
    Object.assign(form,  _.pick(_.get(authStore.user, 'profile'), contactInformationFormItems.value.map(({ key }) => key)), { phone_number: phoneNumber });
  });

return (_ctx: any,_cache: any) => {
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_AppVerificationCodeBtn = _resolveComponent("AppVerificationCodeBtn")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      type: "hidden",
      value: phoneNumberDialCode.value,
      name: "country_code"
    }, null, 8, _hoisted_1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactInformationFormItems), (item) => {
      return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
        key: item.key,
        config: item,
        form: _unref(form),
        onChange: formItemChange
      }, {
        inputBefore: _withCtx(() => [
          (item.key === 'phone_number')
            ? (_openBlock(), _createBlock(_component_AppCountrySelector, {
                key: 0,
                "country-code": countryCode.value || _unref(locale),
                disabled: !isSignup,
                onExcountry: handleGetPhoneNumberCountry
              }, null, 8, ["country-code", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        inputAfter: _withCtx(() => [
          (item.key === 'verification_code')
            ? (_openBlock(), _createBlock(_component_AppVerificationCodeBtn, {
                key: 0,
                target: _unref(phoneNumber),
                insert: "half"
              }, null, 8, ["target"]))
            : _createCommentVNode("", true),
          (item.key === 'phone_number' && !isSignup)
            ? (_openBlock(), _createBlock(_component_b_button, {
                key: 1,
                pill: "",
                style: {"margin-left":"1rem"},
                variant: "outline-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showChangePhoneNumber.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Change')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["config", "form"]))
    }), 128)),
    _createVNode(_component_AppDialog, {
      visible: showChangePhoneNumber.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((showChangePhoneNumber).value = $event)),
      btns: []
    }, {
      default: _withCtx(() => [
        _createVNode(PhoneNumberForm, {
          onSuccess: _cache[1] || (_cache[1] = ($event: any) => (showChangePhoneNumber.value = false))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})